import { Accordion, AccordionItem } from "@r8er/components/marketing/accordion";
import { Container } from "@r8er/components/marketing/container";
import { Content } from "@r8er/components/marketing/content";
import { CtaBlock, Ctas } from "@r8er/components/marketing/ctas";
import ctaClasses from "@r8er/components/marketing/ctas/ctas.module.css";
import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { Newsletter } from "@r8er/components/marketing/newsletter";
import { getAllFaqs } from "@r8er/lib/cms";
import Head from "next/head";
import Link from "next/link";

const Watermark = () => (
  <svg
    style={{
      position: "absolute",
      top: "5rem",
      left: 0,
      transform: "translate(-35%,0)",
      opacity: "50%",
      zIndex: 1,
    }}
    xmlns="http://www.w3.org/2000/svg"
    width="649.6"
    height="1051.7"
  >
    <path
      fill="#f0f0f0"
      d="M516 79a270 270 0 00-382 0 270 270 0 00-23 356l49-48c-56-79-49-190 22-260a203 203 0 01286 0c79 79 79 207 0 286L325 556l-74-73-48 47 122 122 191-191a270 270 0 000-382"
    />
    <path
      fill="#f0f0f0"
      d="M555 497l-15-14-48 47 15 15a258 258 0 010 364 258 258 0 01-364 0 258 258 0 010-364l182-182 74 74 48-48-122-122L95 497a325 325 0 000 460 325 325 0 00460 0 325 325 0 000-460"
    />
  </svg>
);

export default function Faqs({ faqs }) {
  const accordionItems: Array<AccordionItem> = faqs;

  return (
    <div>
      <Head>
        <title>FAQs - R8ER</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero isSlim isTiny title="FAQs" img="/faqs-hero.png" />

        <Content isFullWidth isCentered>
          <p className="p--standard">
            At R8ER, we believe there's no such thing as a silly question, which
            is why we've taken the liberty to place some answers that may help
            with some of our more commonly asked questions. If your question
            cannot be found below, please{" "}
            <Link href="/contact">contact us</Link> and a member of our team
            will reach out to you directly.
          </p>
        </Content>

        <div style={{ position: "relative", overflow: "hidden" }}>
          <Watermark />

          <Content isFullWidth isRightAligned isLightGrey>
            <Container isNarrow>
              <Accordion items={accordionItems} />
            </Container>
          </Content>
        </div>

        <Ctas classList={[ctaClasses.marketing__ctas_faqsCtas]}>
          <CtaBlock
            title="Sign Up to become a R8ER investor"
            img="/cta-investors.png"
            ctaItems={[{ text: "Sign Up Now!", link: "/auth/signup" }]}
            isLight
          />
          <CtaBlock
            title="Sign Up to become a R8ER entrepreneur"
            img="/cta-entrepreneurs.png"
            ctaItems={[
              {
                text: "Sign Up Now!",
                link: "/auth/signup",
              },
            ]}
          />
          <CtaBlock
            title="Speak to a member of the R8ER team"
            img="/cta-contact-light.png"
            ctaItems={[{ text: "Contact Us", link: "/contact" }]}
            isLight
          />
        </Ctas>

        <Newsletter />
      </Layout>
    </div>
  );
}

export async function getStaticProps(context) {
  const faqs = await getAllFaqs();

  const faqContent = faqs.map((faq) => {
    return {
      title: faq.title,
      content: faq.html,
    };
  });

  return {
    props: {
      faqs: faqContent,
    },
  };
}
